// historial-cambio.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  HistorialCambioDto,
  HistorialCambioFilter,
  HistorialCambioEstadisticas
} from '@models/historial-cambio/historial-cambio.models';

@Injectable({
  providedIn: 'root'
})
export class HistorialCambioService {


  constructor(private http: HttpClient) { }

  getAll(): Observable<HistorialCambioDto[]> {
    return this.http.get<HistorialCambioDto[]>(`/api/GetAll`);
  }

  getAllHistorialCambioByFilter(filter: HistorialCambioFilter): Observable<HistorialCambioDto[]> {
    return this.http.post<HistorialCambioDto[]>(
      "/api/HistorialCambio/GetAllHistorialCambioByFilter",
      filter
    );
  }

  getEstadisticasHistorialCambio(filter: HistorialCambioFilter): Observable<HistorialCambioEstadisticas> {
    return this.http.post<HistorialCambioEstadisticas>(
      "/api/HistorialCambio/GetEstadisticasHistorialCambio",
      filter
    );
  }
}
